import styled from 'styled-components';
import { space } from 'styles/variables';
import { label } from 'styles/types';
import { semanticColors } from 'styles/colors';

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 65px);
  left: 0;
  padding-top: 132px;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const TabsContainer = styled.div`
  border-bottom: 1px solid ${semanticColors.border.primary};
`;

export const TabButton = styled.button<{ isActive: boolean }>`
  background: none;
  border: none;
  border-bottom: 2px solid ${props => props.isActive ? semanticColors.border.tertiary : 'transparent'};
  color: ${semanticColors.content.primary};
  cursor: pointer;
  font: ${label.semi.x14};
  letter-spacing: 2px;
  padding: ${space.x2} ${space.x4};
  text-transform: uppercase;
`;

export const TabContent = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  position: relative;
`;

export const LoadingWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`;

export const StyledIFrame = styled.iframe`
  border: 0;
  height: 100%;
  width: 100%;
`;
